var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconocrear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76.11 76.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eventos_seleccionado",
    "data-name": "Eventos seleccionado"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m38.06,22.2V1.46c2.9,1.1,5.56,2.79,7.82,5.04l11.05,11.06c2.26,2.25,3.95,4.92,5.05,7.81h-20.74c-1.75,0-3.17-1.42-3.17-3.17h0Zm4.03,39.58c-2.58,2.58-4.03,6.07-4.03,9.72v4.61h4.61c3.65,0,7.14-1.45,9.72-4.03l21.59-21.59c2.84-2.84,2.84-7.46,0-10.31-2.84-2.84-7.46-2.84-10.31,0l-21.59,21.59h0Zm-10.37,9.72c0-5.37,2.09-10.41,5.88-14.2l21.59-21.59c1.23-1.23,2.67-2.18,4.22-2.86-.01-.38-.03-.76-.05-1.14h-22.12c-5.25,0-9.51-4.27-9.51-9.51V.08c-.51-.03-1.02-.08-1.54-.08h-14.32C7.11,0,0,7.11,0,15.86v44.4c0,8.74,7.11,15.86,15.86,15.86h15.86v-4.61Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconocrear);
export default __webpack_public_path__ + "static/media/icono crear.b0a026f050de4a5eed290c482e2fb355.svg";
export { ForwardRef as ReactComponent };